
import qs from 'qs'
import React from 'react'
import { Link } from 'react-router-dom'
import { withFirestore } from 'react-firestore'
import { InstantSearch, InfiniteHits, SearchBox, Configure } from 'react-instantsearch-dom'

import MsgNetLoading from '../components/MsgNetLoading'
import CompeticionHeaderMenu from '../components/CompeticionHeaderMenu'

import IconFavoriteBorder from '../icons/IconFavoriteBorder'
import '../scss/FavoritoSearch.css'
import config from '../config'
import cookie from 'react-cookies'
import ControlSelector from '../components/ControlSelector'
import SharePanel from '../components/SharePanel'
import TopHeaderMenu from '../components/TopHeaderMenu'
//
// Para non mostrar ningún resultado sin buscar:
// https://codesandbox.io/s/VMKOr8GX
//

function Participante ({ hit, favoritos, onClickFavorito }) {
  const favorito = favoritos.indexOf(hit.dorsal) >= 0
  return <div>
    <button
      className={'search-hit__boton' + (favorito ? ' search-hit__boton--activo' : '')}
      onClick={() => {
        return onClickFavorito(hit.dorsal)
      }}
    >
      <IconFavoriteBorder fill={config.COLOR_BUTTON_ON} />
    </button>
    <Link className={'search-hit__link'} to={`/competicion/${hit.competicion_id}/dorsal/${hit.dorsal}`}>
      <div className={'search-hit__dorsal'}>
        Dorsal <strong>{hit.dorsal}</strong>
        {hit.club && <span> - {hit.club}</span>}
        {hit.localidad && <span> - {hit.localidad}</span>}
      </div>
      <div className={'search-hit__nombre'}>{hit.nombre} {hit.apellidos}</div>
    </Link>
  </div>
}

function Search (props) {
  // console.info(props)

  return (
    <div className='container'>
      <SearchBox translations={{ placeholder: 'nombre, apellidos, dorsal, club, localidad...' }} />
      {/* <Hits hitComponent={(hit) => <Participante hit={hit.hit} favoritos={props.favoritos} onClickFavorito={props.onClickFavorito} />} /> */ }
      <InfiniteHits
        translations={{loadMore: 'Cargar más'}}
        // hasMore={false}
        hitComponent={(hit) => {
          return <Participante
            hit={hit.hit} favoritos={props.favoritos}
            onClickFavorito={props.onClickFavorito} />
        }}
      />
    </div>
  )
}

// Search state to url

// const updateAfter = 700 // ms
//
// const createURL = state => {
//   return `?query=${state.query}`
// }
//
// const searchStateToUrl = (props, searchState) => {
//   if (searchState) {
//     return `${props.location.pathname}${createURL(searchState)}`
//   } else {
//     return ''
//   }
// }

const urlToSearchState = location => {
  // console.info(qs.parse(location.search, { ignoreQueryPrefix: true }))
  const d = qs.parse(location.search, { ignoreQueryPrefix: true })
  // usamos sólo o parámetro <<query>> evitando problemas
  // coa paginación (o estar usando infiniteHits) e cos filtros por competición.
  if (d.query) {
    return { query: d.query }
  } else {
    return { query: '' }
  }
}

class FavoritoSearchScreen extends React.Component {
  constructor (opts) {
    super(opts)
    this.state = {
      evento: null,
      competicion: null,
      favoritos: [],
      searchState: urlToSearchState(this.props.location),
      showSharePanel: false
    }
    this.debouncedSetState = null
  }

  toogleSharePanel () {
    this.setState(state => ({
      showSharePanel: !this.state.showSharePanel
    }))
  }

  UNSAFE_componentWillMount () {  // eslint-disable-line
    const { firestore } = this.props

    const competicionId = parseInt(this.props.match.params.competicionId, 10)
    firestore.doc('competicion/' + competicionId).onSnapshot(snapshot => {
      let competicion = snapshot ? snapshot.data() : null
      if (competicion) {
        competicion.id = snapshot.id
      }
      this.setState({ competicion })
    })

    const favoritos = cookie.load('favoritos-' + competicionId)
    if (favoritos) {
      this.setState({ favoritos: favoritos.map((o) => parseInt(o, 10) || null) })
      // console.info(favoritos)
    }
  }

  UNSAFE_componentWillUpdate (nextProps, nextState) { // eslint-disable-line
    if (this.state.competicion !== nextState.competicion) {
      // Obtenemos el evento
      if (nextState.competicion) {
        this.props.firestore.doc('evento/' + nextState.competicion.evento_id).onSnapshot(snapshot => {
          let evento = snapshot ? snapshot.data() : null
          if (evento) {
            evento.id = snapshot.id
          }
          this.setState({ evento })
        })
      }
    }
  }

  componentWillReceiveProps (props) {
    if (props.location !== this.props.location) {
      this.setState({ searchState: urlToSearchState(props.location) })
    }
  }

  onClickBack () {
    this.props.history.push(`/${this.state.competicion.evento_id}`)
  }

  onClickFavorito (dorsal) {
    const { firestore } = this.props
    const competicionId = parseInt(this.props.match.params.competicionId, 10)

    let favoritos = this.state.favoritos
    let idx = favoritos.indexOf(dorsal)
    if (idx >= 0) {
      // dorsal es favorito ...
      favoritos.splice(idx, 1)
      if (window.FCM_TOKEN) {
        const fstKey = competicionId + '-' + dorsal + '-' + window.FCM_TOKEN
        firestore.collection('fcm').doc(fstKey).delete()
      }
      if (typeof window.ga === 'function') {
        window.ga('set', 'favoritoDel', favoritos.length)
      }
    } else {
      // Añadir y guarder favorito...
      favoritos.push(dorsal)
      if (window.FCM_TOKEN) {
        const fstKey = competicionId + '-' + dorsal + '-' + window.FCM_TOKEN
        firestore.collection('fcm').doc(fstKey).set({
          competicion_id: competicionId,
          dorsal,
          token: window.FCM_TOKEN
        })
      }
      if (typeof window.ga === 'function') {
        window.ga('set', 'favoritoAdd', favoritos.length)
      }
    }

    // console.info(favoritos)
    this.setState({ favoritos })
    const expires = new Date()
    expires.setDate(Date.now() + 1000 * 60 * 60 * 24 * 30) // 30 DIAS
    cookie.save('favoritos-' + competicionId, favoritos, {
      path: '/',
      expires
    })
  }

  onSearchStateChange (searchState) {
    // Esta parte interfiere coa búsqueda e fai mais peticións...
    // clearTimeout(this.debouncedSetState)
    // this.debouncedSetState = setTimeout(() => {
    //   this.props.history.push(
    //     searchStateToUrl(this.props, searchState),
    //     searchState
    //   )
    // }, updateAfter)
    this.setState({ searchState })
  }

  render () {
    const evento = this.state.evento
    const competicion = this.state.competicion
    // https://github.com/algolia/instantsearch.js/issues/2075

    if (this.state.competicion) {
      return <div>
        <TopHeaderMenu
          onClickBack={this.onClickBack.bind(this)}
          onClickShare={this.toogleSharePanel.bind(this)}
          competicion={this.state.competicion}
          evento={this.state.evento}
        />
        <CompeticionHeaderMenu
          competicion={this.state.competicion} selected={4}
          evento={this.state.evento}
        />
        <ControlSelector
          controlList={[]}
          competicion={this.state.competicion}
        />

        {this.state.competicion.visible && (
          <InstantSearch
            appId={config.ALGOLIA_APP_ID}
            apiKey={config.ALGOLIA_SEARCH_KEY}
            indexName={config.ALGOLIA_INDEX_NAME}
            searchState={this.state.searchState}
            onSearchStateChange={this.onSearchStateChange.bind(this)}
          >
            <Configure
              filters={`competicion_id = ${this.props.match.params.competicionId}`}
            />
            <Search favoritos={this.state.favoritos} onClickFavorito={this.onClickFavorito.bind(this)} />
          </InstantSearch>
        )}

        {this.state.showSharePanel && (
          <SharePanel
            close={this.toogleSharePanel.bind(this)}
            url={`/competicion/${competicion.id}/favoritos`}
            title={`Buscar favoritos en la prueba ${competicion.nombre} en ${evento.nombre}`}
          />
        )}
      </div>
    } else {
      return <MsgNetLoading />
    }
  }
}

export default withFirestore(FavoritoSearchScreen)



// WEBPACK FOOTER //
// ./src/containers/FavoritoSearchScreen.js